/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Email_To_Audio_QuestionInputs */

const en_mobile_faq_email_to_audio_question = /** @type {(inputs: Mobile_Faq_Email_To_Audio_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert Email to Audio`)
};

const es_mobile_faq_email_to_audio_question = /** @type {(inputs: Mobile_Faq_Email_To_Audio_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir correo electrónico a audio`)
};

/**
* | output |
* | --- |
* | "Convert Email to Audio" |
*
* @param {Mobile_Faq_Email_To_Audio_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_email_to_audio_question = /** @type {((inputs?: Mobile_Faq_Email_To_Audio_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Email_To_Audio_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_email_to_audio_question(inputs)
	return en_mobile_faq_email_to_audio_question(inputs)
});